import React, { forwardRef } from "react";

export const ActiveTradesLayer = forwardRef(function ActiveTradesLayer(
  { orderTimeMarkers = [] },
  ref,
) {
  return (
    <div ref={ref} className="active-trades-layer" aria-hidden="true">
      {orderTimeMarkers.map((marker) => {
        const tone = marker.side === "down" ? "down" : "up";
        const arrow = tone === "down" ? "▼" : "▲";
        return (
          <div
            key={`live-${marker.id}`}
            className="live-trade-marker"
            data-marker-id={marker.id}
            data-side={marker.side}
            style={{ opacity: 0 }}
          >
            <div className="live-trade-bubble" />
            <span className="chart-annotation__arrowbox" data-tone={tone}>
              <span className="chart-annotation__arrow">{arrow}</span>
            </span>
          </div>
        );
      })}
    </div>
  );
});

